import { useState } from "react";
import { money } from "../../lib/api";

const FIELDS = [
  ["aov", "Average order value ($)", 120], ["n", "Monthly chargebacks", 25], ["rate", "Current chargeback rate (%)", 1.1],
  ["hours", "Hours to defend one chargeback (DIY)", 1.5], ["hourly", "Your hourly rate ($)", 60], ["fee", "Chargeback fee ($)", 25],
  ["winDiy", "DIY win rate (%)", 30], ["winAegis", "Win rate with AEGIS (%)", 55], ["prevent", "Chargebacks prevented (%)", 30],
];

export const roi = (v) => {
  const disputed = v.n * v.aov;
  const diyRec = disputed * (v.winDiy / 100);
  const diyNet = diyRec - v.n * v.hours * v.hourly;
  const aRec = disputed * (v.winAegis / 100);
  const aFee = aRec * 0.15;
  const aNet = aRec - aFee - v.n * 0.25 * v.hourly;
  const prevented = v.n * (v.prevent / 100);
  return { disputed, diyNet, aRec, aFee, aNet, gain: aNet - diyNet, hoursSaved: v.n * (v.hours - 0.25) + prevented * v.hours,
    preventSaved: prevented * (v.aov + v.fee), newRate: v.rate * (1 - v.prevent / 100) };
};

const Out = ({ k, v, big, testid }) => (
  <div className="flex items-baseline justify-between gap-3 py-2 border-b border-divider" data-testid={testid}>
    <span className="text-sm text-white/65">{k}</span><span className={`font-mono tabular ${big ? "text-2xl font-extrabold text-brand" : "text-white"}`}>{v}</span>
  </div>
);

export const RoiCalc = () => {
  const [v, setV] = useState(Object.fromEntries(FIELDS.map(([k, , d]) => [k, d])));
  const r = roi(Object.fromEntries(Object.entries(v).map(([k, x]) => [k, Math.max(0, Number(x) || 0)])));
  return (
    <div className="grid lg:grid-cols-2 gap-6" data-testid="manual-roi">
      <div className="grid sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, l]) => (
          <label key={k} className="block"><span className="label-xs">{l}</span>
            <input type="number" min="0" step="any" value={v[k]} onChange={(e) => setV({ ...v, [k]: e.target.value })}
              className="mt-1 w-full bg-field border border-fieldline px-3 py-2 font-mono text-sm focus:outline-none focus:border-brand" data-testid={`roi-input-${k}`} />
          </label>
        ))}
      </div>
      <div className="panel p-5">
        <Out k="Disputed revenue / month" v={money(r.disputed)} testid="roi-disputed" />
        <Out k="DIY net (recovered − your time)" v={money(r.diyNet)} testid="roi-diy-net" />
        <Out k="Recovered with AEGIS" v={money(r.aRec)} testid="roi-aegis-recovered" />
        <Out k="AEGIS fee (15% of recovered · $0 if you lose)" v={money(r.aFee)} testid="roi-aegis-fee" />
        <Out k="AEGIS net (after fee + 15 min review each)" v={money(r.aNet)} testid="roi-aegis-net" />
        <Out k="Monthly gain vs. doing it yourself" v={money(r.gain)} big testid="roi-gain" />
        <Out k="Hours saved / month" v={r.hoursSaved.toFixed(1)} testid="roi-hours" />
        <Out k="Saved by prevention (orders + fees)" v={money(r.preventSaved)} testid="roi-prevent" />
        <Out k="Chargeback rate after prevention" v={`${r.newRate.toFixed(2)}%`} testid="roi-new-rate" />
        <p className="text-[11px] text-white/40 mt-4">Estimates only. Win rates and prevention vary by industry, evidence and issuer. No monthly minimum.</p>
      </div>
    </div>
  );
};
